import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useMutationSessionPackSubscriptionPendingStartDate({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      subscriptionId,
      startDate,
    }: {
      subscriptionId: number;
      userMemberId: string;
      startDate: string;
    }) =>
      (
        await api.memberApi.sessionPackSubscriptionPendingStartDate({
          subscriptionId,
          startDate,
        })
      ).data,
    onSuccess: async (_, { userMemberId }) => {
      await queryClient.invalidateQueries({
        queryKey:
          memberQueryKeys.userMemberSessionPackSubscriptionCurrent(
            userMemberId,
          ),
      });
    },
  });
}
